import * as types from './actionTypes';

type MyaccountPropsT = {
    profileData?: any;
    profileDataStatus?: any;
    userPrefUpdated?: any;
};

export const myaccountInitialState: MyaccountPropsT = {};

export default function reduce(
    state = myaccountInitialState,
    action: any = {}
) {
    switch (action.type) {
        case types.PROFILE_DATA_FETCHED:
            return {
                ...state,
                profileDataStatus: true,
                profileData: action.profileData,
            };
        case types.PROFILE_DATA_FETCH_FAILED:
            return {
                ...state,
                profileData: action.profileData,
                profileDataStatus: false,
            };
        case types.CLEAR_PROFILE_DATA:
            return {
                ...state,
                profileDataStatus: false,
                profileData: undefined,
                updatingData: false,
            };

        default:
            return state;
    }
}

export function getProfileData(state: any) {
    return state?.myAccount?.profileData;
}
